import React, { useEffect, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import BottomNav from '../Components/BottomNav'
import Topbar from '../Components/Topbar'
import { Modal, Button, Spinner, Table, Form } from 'react-bootstrap'
import { app } from "../firebase.js"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { getFirestore, collection, getDocs, addDoc, query, where, getDoc, doc, orderBy } from "firebase/firestore"
import swal from 'sweetalert';
import VerificationStatus from './VerificationStatus.js'
import noSubs from '../Images/mwanadamu.png'
import { ToastContainer, toast, Bounce } from 'react-toastify';

function Withdraw() {
  const auth = getAuth()
  const db = getFirestore(app)

  const [userId, setUserId] = useState(null)
  const [loading, setLoading] = useState(true)
  const [withdrawals, setWithdrawals] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [withdrawAmount, setWithdrawAmount] = useState('')
  const [processing, setProcessing] = useState(false)
  const [availableBalance, setAvailableBalance] = useState(0)
  const [mpesaNumber, setMpesaNumber] = useState();
  const [theUserEmail, setTheUserEmail] = useState();

  // ====== SEO & Meta Tags ======
  useEffect(() => {
    // Page title
    document.title = "Zindua App | Withdraw Funds";

    // Meta description
    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", "Withdraw your earnings from Zindua App easily via M-Pesa. Track available balance, withdrawal fee, and request history.");

    // Open Graph tags
    const ogTags = [
      { property: "og:title", content: "Zindua App | Withdraw Funds" },
      { property: "og:description", content: "Withdraw your earnings from Zindua App easily via M-Pesa." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://zindua.app/user/withdraw" },
      { property: "og:image", content: "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // JSON-LD structured data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Zindua App Withdraw Funds",
      url: "https://zindua.app/user/withdraw",
      description: "Withdraw your earnings from Zindua App via M-Pesa and track your withdrawal history.",
      publisher: {
        "@type": "Organization",
        name: "Zindua",
        logo: "https://zindua.app/logo192.png",
        sameAs: [
          "https://www.instagram.com/zindua.app/",
          "https://www.linkedin.com/company/zindua-app/",
          "https://www.tiktok.com/@zindua.app"
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Add this function inside your Withdraw component
  const getMpesaFee = (amount) => {
    if (amount <= 100) return 5;
    if (amount <= 500) return 11;
    if (amount <= 1000) return 15;
    if (amount <= 1500) return 18;
    if (amount <= 2500) return 26;
    if (amount <= 3500) return 38;
    if (amount <= 5000) return 50;
    if (amount <= 7500) return 64;
    if (amount <= 20000) return 76;
    return 78; // for 20,001 – 150,000
  };

  // Inside your modal, calculate total and show fee
  const fee = withdrawAmount ? getMpesaFee(Number(withdrawAmount)) : 0;
  const totalAmount = withdrawAmount ? Number(withdrawAmount) + fee : 0;


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) setUserId(user.uid)
      else setUserId(null)
    })
    return () => unsubscribe()
  }, [auth])

  useEffect(() => {
    if (!userId) return

    const fetchData = async () => {
      setLoading(true)
      try {
        // Fetch withdrawals history
        const withdrawalsSnap = await getDocs(
          query(collection(db, "withdrawals"), where("userId", "==", userId), orderBy("timestamp", "desc")
          )
        )
        const withdrawalsData = withdrawalsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        setWithdrawals(withdrawalsData)

        // Fetch paid income payouts
        // Fetch paid income payouts 
        const incomeSnap = await getDocs(
          query(
            collection(db, "income"),
            where("influencerId", "==", userId),
            where("payoutStatus", "==", "Paid")
          )
        )
        const incomeData = incomeSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        const totalPaid = incomeData.reduce((acc, inc) => acc + Number(inc.payout || 0), 0)

        // Subtract withdrawals
        const totalWithdrawn = withdrawalsData.reduce((acc, w) => acc + Number(w.amount || 0), 0)

        setAvailableBalance(totalPaid - totalWithdrawn)

      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [userId, db])

  const handleWithdraw = async () => {
    const amount = Number(withdrawAmount)

    if (!amount || amount <= 0 || amount > availableBalance) {
      swal("Insufficient Amount", "Enter a valid amount within your available balance", "info")
      return
    }

    const fee = getMpesaFee(amount)
    const totalAmount = amount + fee

    if (!totalAmount || totalAmount <= 0 || totalAmount > availableBalance) {
      swal("Insufficient Amount", "Total Balance must include the withdrawal fee", "info")
      return
    }

    toast.success(`please wait....`);

    setProcessing(true)
    try {
      const newWithdrawal = {
        userId,
        amount: totalAmount,
        method: "M-Pesa",
        timestamp: new Date(),
        status: "Pending",
        mpesaNumber,
        withdrawAmount: amount,
        fee,
      }

      await addDoc(collection(db, "withdrawals"), newWithdrawal)
      setWithdrawals(prev => [...prev, newWithdrawal])
      setAvailableBalance(prev => prev - amount) // Only subtract requested amount
      setWithdrawAmount('')
      toast.success(`Processing....`);

      const smsMessage = `Your withdrawal request of KES ${amount.toLocaleString()} has been received. It will be processed within 2 hours.`;

      const emailMessage = `
      <p>Hello,</p>

      <p>We have received your withdrawal request with the following details:</p>

      <p>
        Amount: <strong>KES ${amount.toLocaleString()}</strong><br/>
        Payment Method: M-Pesa<br/>
        Status: Pending verification
      </p>

      <p>
        Our team will review and process your withdrawal within 2 hours.
      </p>

      <p>
        Thank you for using Zindua App.
      </p>

      <p>
        Zindua Team
      </p>
      `;

      await notifyUser(
        mpesaNumber,
        theUserEmail,
        "Withdrawal Request Received",
        emailMessage,
        smsMessage
      );
      setShowModal(false)
      swal("success", "Request has been received. It will be processed within 2 hours", "success").then(() => {
        window.location.reload();
      })

    } catch (err) {
      console.error(err)
      alert("Error processing withdrawal.")
    } finally {
      setProcessing(false)
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return
      const snap = await getDoc(doc(db, "users", user.uid))
      if (!snap.exists()) return

      const data = snap.data()
      const thempesaNumber = data.mpesaNumber;
      const userEmail = data.email;
      setMpesaNumber(thempesaNumber)
      setTheUserEmail(userEmail)
    })

    return () => unsubscribe()
  }, [auth, db])

  const notifyUser = async (phone, email, subject, message, smsMessage) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        console.error("User not authenticated");
        return;
      }

      // Get Firebase ID token
      const token = await user.getIdToken();

      const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      };

      // Send SMS
      if (phone) {
        await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms", {
          method: "POST",
          headers,
          body: JSON.stringify({
            phoneNumber: phone,
            message: smsMessage
          })
        });
      }

      // Send Email
      if (email) {
        await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-email", {
          method: "POST",
          headers,
          body: JSON.stringify({ email, subject, message })
        });
      }

    } catch (err) {
      console.error("Failed to send notification:", err);
    }
  };

  return (
    <div className="mainDashboard">
      <div className="desktopOnly"><LeftBar /></div>

      <div className="mainContent">
        <Topbar />
        <VerificationStatus />

        <section className="withdrawalPage">
          <h3>Withdraw Funds</h3>

          {loading ? (
            <div className="d-flex justify-content-center my-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <div className="balanceSection">
                <div className='alert alert-success'>
                  <p>Available Balance: <strong>KES {availableBalance.toLocaleString()}</strong></p>
                </div>

                <Button onClick={() => setShowModal(true)}>Withdraw to M-Pesa</Button>
              </div>

              <h5 className="mt-4">Withdrawal History</h5>
              {withdrawals.length === 0 ? (

                <div className='noSubscDiv'>
                  <img src={noSubs} className='noSubscImg' alt="" />
                  <p className="text-center mt-4">No withdrawals yet</p>
                </div>
              ) : (
                <Table striped bordered hover className='withdrawalTable'>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount (KES)</th>
                      <th>Method</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {withdrawals.map(w => (
                      <tr key={w.id}>
                        <td>{w.timestamp?.toDate ? w.timestamp.toDate().toLocaleString() : new Date(w.timestamp).toLocaleString()}</td>
                        <td>{Number(w.amount).toLocaleString()}</td>
                        <td>{w.method}</td>
                        <td>{w.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </>
          )}

          {/* Withdraw Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Withdrawal Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <Form.Control
                type="number"
                value={withdrawAmount}
                onChange={e => {
                  const val = Number(e.target.value)
                  if (val > availableBalance) {
                    setWithdrawAmount(availableBalance.toString())
                  } else {
                    setWithdrawAmount(e.target.value)
                  }
                }}
                placeholder={`Max: ${availableBalance}`}
              />

              <Form.Group>
                <Form.Label>M-Pesa Number</Form.Label>
                <Form.Control
                  type="number"
                  value={mpesaNumber}
                  disabled
                />
                <Form.Group>
                  <Form.Label>Withdrawal Fee (KES)</Form.Label>
                  <Form.Control
                    type="number"
                    value={fee}
                    disabled
                  />
                </Form.Group>

                <br />
                <div className='alert alert-primary'>
                  Withdrawals are processed within 2 working hours on weekdays between 8:00 am and 4:00 pm. Requests made outside these hours are handled the next working day.
                </div>

              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleWithdraw} disabled={processing}>
                {processing ? "Processing..." : "Withdraw"}
              </Button>
            </Modal.Footer>
          </Modal>
        </section>
      </div>

      <div className="mobileOnly"><BottomNav /></div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </div>
  )
}

export default Withdraw